<div *ngIf="qssForm" [formGroup]="qssForm" class="grid-container">
    <div>
        <div>
            <h3 class="simulation__paragraph simulation__paragraph--question-preambule" *ngIf="preambuleQuestionsSanteSimplifie.idQuestionsLiees.includes(questionQuestionnaireSanteSimplifie.id)">
                {{ preambuleQuestionsSanteSimplifie.wording }}
            </h3>
            <div class="list-digit__target grid-container">
                <div class="grid-9 grid-mobile-4"></div>
                <div class="grid-12 grid-mobile-4 grid-container">
                    <div class="grid-9 grid-mobile-4 question-title" [innerHTML]="questionQuestionnaireSanteSimplifie.libelle"></div>
                    <div class="grid-3 grid-mobile-4 grid-container buttons">
                        <div class="yesNo-button grid-4 push-3 push-mobile-0">
                            <span class="choice-box choice-box--buttonFull">
                                <input
                                    class="choice--button"
                                    type="radio"
                                    [formControlName]="questionQuestionnaireSanteSimplifie.numero"
                                    [id]="questionQuestionnaireSanteSimplifie.numero + 'No'"
                                    [attr.name]="questionQuestionnaireSanteSimplifie.numero"
                                    required
                                    [value]="false"
                                />
                                <label class="choice-box__label choice-box__label--button" [for]="questionQuestionnaireSanteSimplifie.numero + 'No'">
                                    {{ 'medicalworkflow.question.no' | i18n }}
                                </label>
                            </span>
                        </div>
                        <div class="yesNo-button grid-4 push-4 push-mobile-0 float-mobile-right">
                            <span class="choice-box choice-box--buttonFull">
                                <input
                                    class="choice--button"
                                    type="radio"
                                    [formControlName]="questionQuestionnaireSanteSimplifie.numero"
                                    [id]="questionQuestionnaireSanteSimplifie.numero + 'Yes'"
                                    [attr.name]="questionQuestionnaireSanteSimplifie.numero"
                                    required
                                    [value]="true"
                                />
                                <label class="choice-box__label choice-box__label--button" [for]="questionQuestionnaireSanteSimplifie.numero + 'Yes'">
                                    {{ 'medicalworkflow.question.yes' | i18n }}
                                </label>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
